import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { IAdminPermissions } from 'src/app/feature/admin/models/permission';

// Using Ngrx Entities to address Performance issues in adding facilities.
export const SuperAdminPermissionsAdapter = createEntityAdapter<IAdminPermissions>({ selectId: (item: IAdminPermissions) => item.transactionId });

export interface SuperAdminPermissionsState extends EntityState<IAdminPermissions> {
  selectedPermissionId: number | null;
  isLoaded: boolean;
  serverError: boolean;
}

export const intialAdminPermissionsState: SuperAdminPermissionsState = SuperAdminPermissionsAdapter.getInitialState({
  selectedPermissionId: null,
  isLoaded: false,
  serverError: false
});

const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = SuperAdminPermissionsAdapter.getSelectors();

export const selectSuperAdminPermissionsEntities = selectEntities;

export const selectAllSuperAdminPermissionsEntities = selectAll;

export const selectAllSuperAdminPermissionsIds = selectIds;

export const selectIsLoaded = (state: SuperAdminPermissionsState) => state.isLoaded;

export const selectServerError = (state: SuperAdminPermissionsState) => state.serverError;
